import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { Unit } from '../../models/Unit';

export interface UnitState {
  value: Unit | undefined;
}

const initialState: UnitState = { value: undefined };

export const unitSlice = createSlice({
  name: 'unit',
  initialState,
  reducers: {
    setUnit: (state: UnitState, action: PayloadAction<Unit | undefined>) => {
      state.value = action.payload;
    },
  },
});

export const selectedUnit = (state: RootState) => state.unit.value;

export const { setUnit } = unitSlice.actions;

export default unitSlice.reducer;
